import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { AlertList } from 'react-bs-notifier';
import DialogList from '../../components/DialogList';
import actionsAndConstants from '../../shared/actionsAndConstants';
import { ALERTS_TIMEOUT } from '../../shared/constants';

const { app: { actions: appActions } } = actionsAndConstants;

const actions = {
  clearAlert: appActions.clearAlert,
  hideDialog: appActions.hideDialog
};

const App = (props) => {
  const {
    alerts,
    actions: {
      clearAlert,
      hideDialog
    },
    children,
  } = props;
  return (
    <div>
      <AlertList
        alerts={alerts}
        timeout={ALERTS_TIMEOUT}
        onDismiss={clearAlert}
      />
      <DialogList onDismiss={hideDialog} />
      {children}
    </div>
  );
};

App.propTypes = {
  actions: PropTypes.shape({
    clearAlert: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired
  }).isRequired,
  alerts: PropTypes.arrayOf(PropTypes.shape({
    message: PropTypes.string.isRequired,
    type: PropTypes.string.isRequired
  })).isRequired,
  children: PropTypes.element.isRequired
};

const mapStateToProps = ({ alerts }) => ({
  alerts
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(App);



// WEBPACK FOOTER //
// ./src/containers/App/index.js